import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSheet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.746684,0,-0.384377,0.746684,41.5131,14.6702)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: 9.586,
			y: 11.549,
			width: 109.076,
			height: 109.032
		})
	})
});
export default SvgSheet;
